export default "__VITE_ASSET__325fefe2__"